import { NgModule } from '@angular/core';

import { imports } from './app-imports.module';
import { providers } from './app-providers.module';

import { AppComponent } from './app.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  imports,
  providers,
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
